import { PaymentData } from '@hotjar/webapp/billing/plan';

angular.module('hjApp').controller('ModalBillingWarning', [
    'warningType',
    'warningData',
    '$filter',
    '$modalInstance',
    '$scope',
    'Feature',
    'Subscription',
    'Track',
    function (warningType, warningData, $filter, $modalInstance, $scope, Feature, Subscription, Track) {
        /************************
         * PRIVATE VARIABLES
         ************************/
        var account = warningData.account,
            readableWarningType = getReadableWarningType(),
            modalName = 'Billing warning - ' + readableWarningType, // Used for tracking.
            groupDataForAccount = Track.getGroupDataForAccount(account),
            eventData = {
                modal_version: warningData.isAccountOwner ? 'Account owner' : 'Not account owner'
            };

        function trackModalLoaded() {
            Track.loadedModal(modalName, groupDataForAccount, eventData);
        }

        function trackModalClosed() {
            Track.closedModal(modalName, groupDataForAccount, eventData);
        }

        /************************
         * PRIVATE FUNCTIONS
         ************************/

        /**
         * Get a readable version of warning type, used for tracking.
         * e.g. recurring-payment-failed = Recurring Payment Failed
         */
        function getReadableWarningType() {
            return $filter('capitalize')(warningType.split('-').join(' '));
        }

        /**
         * Check if the grace period is over.
         * The grace period is a period of time (days) of how long paid plans
         * are kept effective before we switch them to "basic" if payment is
         * not settled for the subscription.
         *
         * Note: the grace period is in reality 21 days, however
         * we are calculating from the LAST attempt, which is
         * 7 days after the billing date.
         */
        function isGracePeriodOver() {
            var gracePeriodDaysAfterLastAttempt = 14;

            return (
                warningData.subscriptionInfo.recurringPayment.failureCount >= 3 &&
                $filter('daysAgo')(warningData.subscriptionInfo.recurringPayment.lastFailureDate) >
                    gracePeriodDaysAfterLastAttempt
            );
        }

        /**
         * Retrieve a string, using site names to show in the template.
         *
         * @param sites A list of site objects.
         */
        function getSiteNames(sites) {
            var names = _.pluck(sites.slice(0, 3), 'name'),
                text = 'your site';

            if (sites.length > 0 && sites.length <= 2) {
                text = names.join(' and ');
            } else if (sites.length >= 3) {
                text = names[0] + ', ' + names[1] + ' and ' + (sites.length - 2) + ' other sites';
            }

            return text;
        }

        /************************
         * SCOPE VARIABLES
         ************************/
        $scope.model = {
            isAccountOwner: warningData.isAccountOwner,
            gracePeriodOver: isGracePeriodOver(),
            owner: warningData.subscriptionInfo.accountOwner,
            paymentMethod: warningData.subscriptionInfo.paymentMethod,
            recurringPayment: warningData.subscriptionInfo.recurringPayment,
            siteNames: getSiteNames(warningData.sites),
            warningType: warningType
        };

        trackModalLoaded();

        /************************
         * SCOPE FUNCTIONS.
         ************************/
        $scope.close = function close() {
            trackModalClosed();
            $modalInstance.close();
        };

        $scope.updatePaymentMethod = function updatePaymentMethod() {
            var paymentData = new PaymentData(undefined, undefined, `Billing warning modal: ${readableWarningType}`);

            Subscription.updatePaymentMethod(account, paymentData);

            $modalInstance.close();
        };
    }
]);
